
















































import Vue from "vue";

import { IpaEvaluated } from "@joyz/app-core/models/typography";

import {
  ApiDrillPronunciation,
  DrillPronunciationAnswer,
  DrillQuestionAndAnswers
} from "@tt-app/models/exercise";
import DrillAnswerPronunciation from "./DrillAnswerPronunciation.vue";

import IconDictionary from "@joyz/app-core/assets/icons/default/Dictionary.svg";
import DictionarySentenceModal from "@tt-app/components/exercise/SingleSentenceReading/DictionarySentenceModal.vue";

interface Data {
  audioElement?: HTMLAudioElement;
  audioProgress: number;
  dictionaryModal: {
    open: boolean;
  };
  icons: any;
  playingElement?: any;
}

interface Computed {
  dictionaryAvailable: boolean;
  drillQuestion: ApiDrillPronunciation;
  ipa: IpaEvaluated[];
}

interface Props {
  drillExercise: DrillQuestionAndAnswers;
}

interface Methods {
  dictionaryModalCloseHandler: () => void;
  dictionaryModalOpenHandler: () => void;
  exampleAudioButtonClickHandler: (event: any) => void;
  startAudioPlayback: (event: any) => void;
  timeUpdateHandler: (event: any) => void;
}

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "DrillReviewPronunciation",
  components: { DictionarySentenceModal, DrillAnswerPronunciation },

  props: {
    drillExercise: { type: Object as () => DrillQuestionAndAnswers, required: true }
  },

  data() {
    return {
      audioElement: undefined,
      audioProgress: 0,
      dictionaryModal: {
        open: false
      },
      icons: {
        dictionary: IconDictionary
      },
      playingElement: undefined
    };
  },

  mounted() {
    this.audioElement = this.$refs.audio as HTMLAudioElement;
  },

  computed: {
    dictionaryAvailable() {
      return (this.drillExercise.question as ApiDrillPronunciation).word.definition !== null;
    },

    drillQuestion() {
      return this.drillExercise.question as ApiDrillPronunciation;
    },

    ipa() {
      const allAnswers = this.drillExercise.allAnswers;
      if (allAnswers.length === 0) {
        return [];
      }

      // Display the first answer IPA evaluation
      return (allAnswers[0].submittedAnswer as DrillPronunciationAnswer).evaluation.map(
        (e): IpaEvaluated => ({ text: e.ipa, isCorrect: e.isCorrect })
      );
    }
  },
  methods: {
    dictionaryModalCloseHandler() {
      this.dictionaryModal.open = false;
    },

    dictionaryModalOpenHandler() {
      this.dictionaryModal.open = true;
    },

    exampleAudioButtonClickHandler(event) {
      this.startAudioPlayback(event);
    },

    startAudioPlayback(event) {
      this.playingElement = event.currentTarget;

      const audioUrl = this.playingElement.getAttribute("src");

      this.$emit("play-example-audio", { audioUrl });
    },

    timeUpdateHandler(event) {
      this.audioProgress = (event.target.currentTime / event.target.duration) * 100;
    }
  }
});
